/* tslint:disable */
/* eslint-disable */
/**
 * DynamicForms.Server | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { BaseThemeFromJSON, ThemeListFromJSON, } from '../models/index';
/**
 *
 */
export class ThemesApi extends runtime.BaseAPI {
    /**
     */
    apiThemesFormsDocumentIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['documentId'] == null) {
                throw new runtime.RequiredError('documentId', 'Required parameter "documentId" was null or undefined when calling apiThemesFormsDocumentIdGet().');
            }
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/api/Themes/forms/{documentId}`;
            urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));
            const response = yield this.request({
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ThemeListFromJSON(jsonValue));
        });
    }
    /**
     */
    apiThemesFormsDocumentIdGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiThemesFormsDocumentIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiThemesGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/api/Themes`;
            const response = yield this.request({
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => BaseThemeFromJSON(jsonValue));
        });
    }
    /**
     */
    apiThemesGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiThemesGetRaw(initOverrides);
            return yield response.value();
        });
    }
}
